import React from "react";
import "./Departments.css";


const MahilaBalKalyanVibhag = () => {
  return (
    <div className="dept-page">

      {/* TOP STRIP */}
      <div className="dept-top-strip">
        <span>🏛 महाराष्ट्र शासन</span>
        <span>महिला व बालकल्याण विभाग</span>
      </div>

      {/* HEADER */}
      <header className="dept-header">
        <div className="dept-header-emblem">👩‍👧</div>

        <div className="dept-header-text">
          <div className="dept-header-org">
            जिल्हा परिषद विभाग
          </div>

          <h1 className="dept-header-title">
            महिला व बालकल्याण विभाग
          </h1>

          <div className="dept-header-subtitle">
            एकात्मिक बाल विकास सेवा योजना
          </div>
        </div>

        <div className="dept-header-badge">
          ICDS SERVICES
        </div>
      </header>

      {/* NAVIGATION */}
      <div className="dept-nav">
        <button className="dept-nav-tab active">
          विभाग माहिती
        </button>

        <button className="dept-nav-tab">
          सेवा
        </button>

        <button className="dept-nav-tab">
          अंगणवाडी योजना
        </button>

        <button className="dept-nav-tab">
          संपर्क
        </button>
      </div>

      {/* MAIN CONTENT */}
      <main className="dept-main">

        {/* HERO INTRO */}
        <section className="dept-intro">

          <div className="dept-intro-label">
            महिला व बाल विकास सेवा
          </div>

          <p className="dept-intro-text">
            <strong>एकात्मिक बाल विकास सेवा योजना</strong> ही केंद्र पुरस्कृत योजना असून
            जिल्ह्यातील 13 तालुक्यांमध्ये 22 प्रकल्पांतर्गत
            <strong> 4395 अंगणवाडी केंद्रे </strong>
            कार्यरत आहेत. या योजनेद्वारे बालकांचे आरोग्य,
            पोषण, शिक्षण व विकासासाठी विविध सेवा उपलब्ध
            करून देण्यात येतात.
          </p>

        </section>

        {/* STATS */}
        <section className="dept-stats">

          <div className="dept-stat-card">
            <div className="dept-stat-value">13</div>
            <div className="dept-stat-label">
              तालुके
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">22</div>
            <div className="dept-stat-label">
              प्रकल्प
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">4395</div>
            <div className="dept-stat-label">
              अंगणवाडी केंद्रे
            </div>
          </div>

          <div className="dept-stat-card">
            <div className="dept-stat-value">6</div>
            <div className="dept-stat-label">
              प्रमुख सेवा
            </div>
          </div>

        </section>

        {/* LEFT CONTENT */}
        <div>

          {/* SERVICES SECTION */}
          <section className="dept-section">

            <div className="dept-section-header">

              <div className="dept-section-icon">
                🧒
              </div>

              <h2 className="dept-section-title">
                अंगणवाडी केंद्रांमधील सेवा
              </h2>

            </div>

            <div className="scheme-list">

              <div className="scheme-card">
                <div className="scheme-card-name">
                  पूरक पोषण आहार
                </div>

                <div className="scheme-card-desc">
                  अंगणवाडी केंद्रांमधील लाभार्थ्यांना पूरक
                  पोषण आहार देण्यात येतो.
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  लसीकरण सेवा
                </div>

                <div className="scheme-card-desc">
                  अंगणवाडी मधील बालकांचे नियमित लसीकरण
                  करण्यात येते.
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  आरोग्य तपासणी
                </div>

                <div className="scheme-card-desc">
                  अंगणवाडी मधील बालकांची आरोग्य तपासणी
                  करण्यात येते.
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  संदर्भ आरोग्य सेवा
                </div>

                <div className="scheme-card-desc">
                  आजारी बालकांना संदर्भ आरोग्य सेवा
                  देण्यात येते.
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  आहार व आरोग्य शिक्षण
                </div>

                <div className="scheme-card-desc">
                  लाभार्थ्यांना आहार व आरोग्य विषयक
                  शिक्षण देण्यात येते.
                </div>
              </div>

              <div className="scheme-card">
                <div className="scheme-card-name">
                  शालापूर्व शिक्षण
                </div>

                <div className="scheme-card-desc">
                  अंगणवाडीतील बालकांना अनौपचारिक
                  शालापूर्व शिक्षण देण्यात येते.
                </div>
              </div>

            </div>

          </section>

          {/* BUILDING SECTION */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                🏢
              </div>

              <h2 className="dept-section-title">
                अंगणवाडी इमारत योजना
              </h2>

            </div>

            <div className="dept-highlight-box">

              <div className="dept-highlight-box-title">
                🏗 अंगणवाडी इमारत बांधकाम
              </div>

              <p>
                अंगणवाडी केंद्रास स्वतःची इमारत नसल्यास
                विहीत नमुन्यात प्रस्ताव गट विकास अधिकारी
                यांच्या स्वाक्षरीने महिला व बाल कल्याण
                विभागाकडे सादर करण्यात यावा.
                जिल्हा वार्षिक-सर्वसाधारण योजनेतून
                सदर कामे मंजूर करून इमारत बांधकाम
                करण्यात येते.
              </p>

            </div>

            <div
              className="dept-highlight-box"
              style={{ marginTop: "18px" }}
            >

              <div className="dept-highlight-box-title">
                🛠 अंगणवाडी इमारत दुरुस्ती
              </div>

              <p>
                अंगणवाडी इमारत 10 वर्षे जुनी असल्यास
                व किरकोळ दुरुस्तीची आवश्यकता असल्यास
                अंदाजपत्रकासह प्रस्ताव महिला व बाल
                कल्याण विभागाकडे सादर करावा.
                दुरुस्तीची कामे जिल्हा वार्षिक-सर्वसाधारण
                योजनेतून मंजूर करण्यात येतात.
              </p>

            </div>

          </section>

          {/* ONLINE SERVICES */}
          <section
            className="dept-section"
            style={{ marginTop: "24px" }}
          >

            <div className="dept-section-header">

              <div className="dept-section-icon">
                💻
              </div>

              <h2 className="dept-section-title">
                ऑनलाईन सेवा
              </h2>

            </div>

            <p
              style={{
                fontSize: "0.92rem",
                lineHeight: "1.8",
                color: "var(--text-mid)"
              }}
            >
              लोकसेवा हक्क अधिनियम 2015 अंतर्गत
              महिला व बालकल्याण विभागाकडील
              अधिसूचित केलेल्या ऑनलाईन सेवांचा
              लाभ नागरिकांना उपलब्ध करून देण्यात येतो.
            </p>

          </section>

        </div>

        {/* SIDEBAR */}
        <aside className="dept-sidebar">

          {/* INFO CARD */}
          <div className="dept-info-card">

            <div className="dept-info-card-title">
              विभाग माहिती
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                योजना
              </div>

              <div className="dept-info-val">
                एकात्मिक बाल विकास सेवा
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                तालुके
              </div>

              <div className="dept-info-val">
                13
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                प्रकल्प
              </div>

              <div className="dept-info-val">
                22
              </div>
            </div>

            <div className="dept-info-row">
              <div className="dept-info-key">
                अंगणवाडी केंद्रे
              </div>

              <div className="dept-info-val">
                4395
              </div>
            </div>

          </div>

          {/* CONTACT CARD */}
          <div className="dept-contact-card">

            <div className="dept-contact-card-title">
              संपर्क माहिती
            </div>

            <div className="dept-contact-row">
              <span>📞</span>
              <span>020-26054299</span>
            </div>

            <div className="dept-contact-row">
              <span>📍</span>
              <span>जिल्हास्तरीय कार्यालये</span>
            </div>

          </div>

          {/* QUICK SERVICES */}
          <div className="dept-info-card">

            <div className="dept-info-card-title">
              प्रमुख सेवा
            </div>

            <div className="dept-services-grid">

              <div className="dept-service-item">
                पोषण आहार
              </div>

              <div className="dept-service-item">
                लसीकरण
              </div>

              <div className="dept-service-item">
                आरोग्य तपासणी
              </div>

              <div className="dept-service-item">
                आरोग्य सेवा
              </div>

              <div className="dept-service-item">
                शालापूर्व शिक्षण
              </div>

              <div className="dept-service-item">
                पोषण मार्गदर्शन
              </div>

            </div>

          </div>

        </aside>

      </main>

      {/* FOOTER */}
      <footer className="dept-footer">
        <strong>
          महिला व बालकल्याण विभाग
        </strong>
        {" "}• जिल्हा परिषद प्रशासन
      </footer>

    </div>
  );
};

export default MahilaBalKalyanVibhag;